var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEscalateImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 44C88 68.3005 68.3005 88 44 88C19.6995 88 0 68.3005 0 44C0 19.6995 19.6995 0 44 0C68.3005 0 88 19.6995 88 44ZM6.6 44C6.6 64.6554 23.3445 81.4 44 81.4C64.6554 81.4 81.4 64.6554 81.4 44C81.4 23.3445 64.6554 6.6 44 6.6C23.3445 6.6 6.6 23.3445 6.6 44Z",
    fill: "url(#paint0_linear_1671_24286)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7 44C86.5225 44 88.0129 45.4795 87.8763 47.297C87.4403 53.1002 85.8562 58.7708 83.2043 63.9756C80.5523 69.1804 76.8958 73.7949 72.4571 77.5588C71.0671 78.7375 68.9941 78.4015 67.9229 76.927C66.8516 75.4525 67.1896 73.3994 68.564 72.2023C72.1678 69.0634 75.1447 65.2557 77.3236 60.9792C79.5026 56.7028 80.8334 52.0564 81.2545 47.2958C81.4151 45.4803 82.8775 44 84.7 44Z",
    fill: "#1671ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1671_24286",
    x1: 0.598053,
    y1: 0,
    x2: 0.598053,
    y2: 86.8039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1671ED",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EC7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalateImage);
export default __webpack_public_path__ + "static/media/escalate-image.01e8bd14.svg";
export { ForwardRef as ReactComponent };